import { render, staticRenderFns } from "./Signal.vue?vue&type=template&id=64125e42&scoped=true"
import script from "./Signal.vue?vue&type=script&lang=js"
export * from "./Signal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64125e42",
  null
  
)

export default component.exports